import { createSlice, createAsyncThunk, type PayloadAction } from '@reduxjs/toolkit';
import type { ReporteModel } from 'models/reporte_model';
import { getReporte, downloadReporteExcel, type ReporteFiltros } from 'repositories/reporte_repository';

type ReporteState = ReporteModel & {
  loading: boolean;
  error: string | null;
};

const initialState: ReporteState = {
  rows: [],
  columns: [],
  count: 0,
  loading: false,
  error: null,
};

export const cargarReporte = createAsyncThunk(
  'reporte/cargarReporte',
  async (
    params: {
      tipoReporte?: string;
      desde?: string | null;
      hasta?: string | null;
      filtros?: ReporteFiltros;
    } = {},
    { rejectWithValue },
  ) => {
    try {
      return await getReporte(params.tipoReporte, params.desde, params.hasta, params.filtros);
    } catch {
      return rejectWithValue('Error al cargar reporte');
    }
  },
);

export const descargarReporteExcel = createAsyncThunk(
  'reporte/descargarExcel',
  async (
    params: {
      tipoReporte?: string;
      desde?: string | null;
      hasta?: string | null;
      filtros?: ReporteFiltros;
    } = {},
    { rejectWithValue },
  ) => {
    try {
      await downloadReporteExcel(params.tipoReporte, params.desde, params.hasta, params.filtros);
    } catch {
      return rejectWithValue('Error al descargar reporte');
    }
  },
);

export const reporteSlice = createSlice({
  name: 'reporte',
  initialState,
  reducers: {
    setReporte: (state, action: PayloadAction<ReporteModel>) => {
      state.rows = action.payload.rows;
      state.columns = action.payload.columns;
      state.count = action.payload.count;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(cargarReporte.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(cargarReporte.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload as ReporteModel;
        state.rows = data.rows ?? [];
        state.columns = data.columns ?? [];
        state.count = data.count ?? 0;
      })
      .addCase(cargarReporte.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setReporte } = reporteSlice.actions;
export default reporteSlice.reducer;
